import {axios} from '../../services/axios';

export default async function getPartnerPlans(partnerId) {
    return axios
        .get(`/Partner/${partnerId}/Plans`, partnerId)
        .then((res) => res)
        .catch((e) => e);
}
